module.exports = __webpack_public_path__ + "static/media/ex4.5f2eee29.jpg";